// File: src/components/hooks/PasswordStrength.js
import React, { useEffect, useRef } from 'react';
import passwordStrengthMeter from '@fntools/pswmeter/pswmeter.js';


export default function PasswordStrength({ inputId, containerId, messageId }) {
    const containerRef = useRef(null);
    const messageRef = useRef(null);

    useEffect(() => {
        if (typeof passwordStrengthMeter === 'function') {
            passwordStrengthMeter({
                containerElement: `#${containerId}`,
                passwordInput: `#${inputId}`,
                height: 6,
                borderRadius: 6,
                showMessage: true,
                messageContainer: `#${messageId}`,
                messagesList: [
                    'Enter a password',
                    'Too simple',
                    'Simple',
                    'That’s OK',
                    'Great password!'
                ]
            });
        } else {
            console.error('No passwordStrengthMeter function available');
        }
    }, [inputId, containerId, messageId]);

    return (
        <>
            <div id={containerId} ref={containerRef} className="mt-2" />
            <div id={messageId} ref={messageRef} className="rounded mt-1" />
        </>
    );
}
